{
  "processPage": {
    "assignmentTitle": "Examiner l'attribution d'étape de processus",
    "assignmentDescription": "Vérifiez les détails de l'attribution. Si tout convient, acceptez et commencez l'enregistrement de votre étape de processus. Si vous n'êtes pas la bonne personne, attribuez l'étape à quelqu'un d'autre.",
    "YourProcessStep": "Votre étape de processus",
    "ProcessStart": "Début du processus",
    "Output": "Sortie",
    "Successor": "Successeur",
    "Assignee": "Assigné",
    "chooseAllSuccessor": "Choisissez tous les successeurs qui recevront votre sortie.",
    "chooseAllSuccessorDecision": "Choisissez tous les successeurs qui continueront le processus avec cette option.",
    "chooseASuccessor": "Choisissez un successeur qui recevra votre sortie.",
    "chooseAllAssignee": "Choisissez toutes les personnes qui peuvent démarrer le processus.",
    "chooseAnAssignee": "Choisissez qui démarrera le processus.",
    "aSuccessorCanBe": "Un successeur peut être une personne, une fonction, un système ou un contact externe.",
    "anAssigneeCanBe": "Un assigné peut être une personne, une fonction ou un système.",
    "addSuccessor": "Ajouter un successeur",
    "addAssignee": "Ajouter un assigné",
    "whoElseDoesThis": "Qui d'autre fait cela ?",
    "selectColleaguesWhoAlsoPerform": "Sélectionnez les personnes qui pourraient prendre en charge cette étape indépendamment de vous – p. ex. en remplacement. Plusieurs choix possibles.",
    "statusPending": "En attente",
    "Person": "Personne",
    "thisPersonWillReceive": "Cette personne recevra une invitation pour décrire la prochaine étape de processus.",
    "thisPersonWillReceiveStart": "Cette personne sera invitée à décrire la première étape de processus.",
    "teamWillReceive": "Cette fonction recevra une invitation pour décrire la prochaine étape de processus.",
    "teamWillReceiveStart": "Cette fonction sera invitée à décrire la première étape de processus.",
    "Unclear": "Incertain",
    "processWillEnd": "La séquence du processus se termine ici",
    "processWillReturnToOwner": "Le processus sera renvoyé au propriétaire du processus",
    "None": "Aucun successeur",
    "systemOwnerWillReceive": "Le propriétaire du système sera invité à décrire la prochaine étape de processus.",
    "systemOwnerWillReceiveStart": "Le propriétaire du système sera invité à décrire la première étape de processus.",
    "externalContactOwnerWillReceive": "Le propriétaire du processus sera invité à décrire l'étape au nom du contact externe.",
    "selectPersonPlaceholder": "Choisir une personne...",
    "selectSystemPlaceholder": "Choisir un système logiciel...",
    "selectExternalContactPlaceholder": "Choisir un contact externe...",
    "Processname": "Nom du processus",
    "processFlow": "Flux du processus",
    "processFlowDescription": "Voir le diagramme complet du flux de processus montrant toutes les étapes enregistrées",
    "showInProcess": "Afficher dans le processus",
    "viewProcessDetails": "Voir les détails du processus",
    "assignSomeoneElse": "Assigner quelqu'un d'autre",
    "Saved": "Enregistré",
    "unsavedChanges": "Modifications non enregistrées",
    "processNameDesc": "Détails du processus",
    "multiple-times-daily": "Plusieurs fois par jour",
    "once-a-day": "Une fois par jour",
    "several-times-a-week": "Plusieurs fois par semaine",
    "once-per-week": "Une fois par semaine",
    "every-two-weeks": "Toutes les deux semaines",
    "every-three-weeks": "Toutes les trois semaines",
    "monthly": "Mensuel",
    "quarterly": "Trimestriel",
    "semi-annually": "Semestriel",
    "yearly": "Annuel",
    "LastChange": "Dernière modification",
    "ProcessStepMembers": "Personnes de l'étape de processus",
    "ProcessStep": "Étape de processus",
    "Check": "Vérifier",
    "ratingRequired": "L'évaluation est requise",
    "Saving": "Enregistrement...",
    "surveyRequired": "Veuillez fournir une réponse",
    "total": "Total : {{total}}",
    "showSelected": "Afficher les sélectionnés ({{amount}})",
    "Reassign": "Réassigner",
    "AllDepartments": "Tous les départements"
  },
  "processFlow": {
    "bpmnPreview": "Aperçu du processus",
    "openFullscreen": "Ouvrir en plein écran",
    "fullscreenTitle": "Visualisation du flux de processus",
    "viewMode": {
      "label": "Vue",
      "standard": "Standard",
      "rating": "Par évaluation",
      "capacity": "Par charge de capacité",
      "combined": "Score combiné"
    },
    "heatmapLegend": {
      "noData": "Aucune donnée",
      "rating": {
        "good": "Moy. ≥ {{min}} étoiles",
        "medium": "Moy. {{min}} – {{max}} étoiles",
        "critical": "Moy. < {{min}} étoiles"
      },
      "capacity": {
        "good": "< {{max}} % du maximum",
        "medium": "{{min}} – {{max}} % du maximum",
        "critical": "≥ {{min}} % du maximum"
      },
      "combined": {
        "good": "Score ≥ {{min}} %",
        "medium": "Score {{min}} – {{max}} %",
        "critical": "Score < {{max}} %"
      },
      "hoursUnit": "h",
      "combinedInfo": "Le score combiné évalue chaque étape de 0 à 100 % en combinant deux éléments : la qualité de sa note (60 %) et la légèreté de sa charge de capacité (40 %) — une étape qui mobilise moins d'heures obtient un score plus élevé. Le vert indique un bon résultat sur les deux plans ; le rouge signale une mauvaise note, une charge de capacité élevée, ou les deux."
    },
    "stepDetails": "Détails de l'étape {{number}}",
    "stepPrefix": "Étape {{number}}",
    "decision": "Décision",
    "assignedTo": "Assigné à",
    "recordedBy": "Enregistré par",
    "taskDescription": "Description de la tâche",
    "inputs": "Entrées",
    "inputsHint": "Ajoutez ici tout ce qui entre et dont vous avez besoin pour réaliser l'étape de processus : un événement qui déclenche l'étape (p. ex. réunion trimestrielle) ou une information que vous traitez (p. ex. un rapport ou un indicateur). Les simples ouvrages de référence comme les directives relèvent en revanche des « Documents ».",
    "helpers": "Assistants",
    "helpersHint": "Avec quoi et avec qui réalisez-vous cette étape ? Les systèmes utilisés, les personnes et fonctions obligatoirement impliquées et les documents nécessaires.",
    "persons": "Personne(s)",
    "teams": "Fonction(s)",
    "systems": "Système(s)",
    "documents": "Document(s)",
    "successors": "Successeurs",
    "noSuccessors": "Le processus se termine ici",
    "unclearSuccessors": "Continuation incertaine",
    "pendingSystem": "Système suggéré",
    "pendingOrgFunction": "Fonction suggérée",
    "decisionRules": "Règles de décision",
    "whoElseDoesThis": "Qui d'autre fait cela",
    "whoElseDoesThisDescription": "Sélectionnez les personnes qui pourraient prendre en charge cette étape indépendamment de vous – p. ex. en remplacement. Plusieurs choix possibles.",
    "whoElseDoesThisDescriptionEditor": "Personnes qui exécutent également cette étape – p. ex. en remplacement. Plusieurs possibles.",
    "status": {
      "pending": "En attente",
      "accepted": "Accepté",
      "declined": "Refusé"
    },
    "feedback": "Retour",
    "variantCheck": {
      "title": "Vérification des variantes",
      "same": "à l’identique",
      "different": "différemment",
      "notPerformed": "non effectué",
      "viewVariants": "Voir les variantes"
    },
    "createdAt": "Créé",
    "updatedAt": "Mis à jour",
    "completedAt": "Terminé",
    "noStepsRecorded": "Aucune étape de processus enregistrée pour le moment",
    "startRecordingHint": "Démarrez l'enregistrement pour voir le flux de processus",
    "output": "Résultat",
    "expandTable": "Agrandir le tableau",
    "endLabel": "Fin",
    "noFurtherSteps": "Aucune étape suivante",
    "unclearContinuation": "Suite indéterminée",
    "swimlane": {
      "unassigned": "Non assigné"
    },
    "viralPlaceholder": {
      "pending": "En attente d'enregistrement",
      "accepted": "Enregistrement en cours",
      "pendingUnclear": "Indéterminé — en attente de résolution par le propriétaire du processus",
      "proposed": "Proposé — en attente d'approbation",
      "declined": "Proposé — refusé"
    },
    "editable": {
      "noAssignee": "Aucun responsable",
      "addInput": "Ajouter une entrée",
      "reorderInput": "Glisser pour réorganiser l'entrée",
      "removeInput": "Supprimer l'entrée",
      "addHelper": "Ajouter un intervenant",
      "addArtifact": "Ajouter un nouveau document",
      "noSuccessors": "Aucun successeur défini",
      "addSuccessor": "Ajouter un successeur",
      "removeSuccessor": "Retirer le successeur",
      "noDecisionRules": "Aucune règle de décision définie",
      "editDecisionRules": "Modifier les règles de décision",
      "noHelpers": "Aucun intervenant sélectionné",
      "editHelpers": "Modifier les intervenants",
      "editHelpersDescription": "Sélectionnez des personnes, des fonctions et des systèmes qui aident à cette étape.",
      "none": "Aucun",
      "personsCount": "{{count}} personnes",
      "personsCount_one": "{{count}} personne",
      "personsCount_other": "{{count}} personnes",
      "teamsCount": "{{count}} fonctions",
      "teamsCount_one": "{{count}} fonction",
      "teamsCount_other": "{{count}} fonctions",
      "systemsCount": "{{count}} systèmes",
      "systemsCount_one": "{{count}} système",
      "systemsCount_other": "{{count}} systèmes",
      "documentsCount": "{{count}} documents",
      "documentsCount_one": "{{count}} document",
      "documentsCount_other": "{{count}} documents"
    },
    "contextMenu": {
      "addStep": "Ajouter une étape",
      "addEvent": "Ajouter un événement",
      "addEventForStep": "Ajouter un événement pour l'étape",
      "editStep": "Modifier l'étape",
      "deleteStep": "Supprimer l'étape",
      "editEvent": "Modifier l'événement",
      "deleteEvent": "Supprimer l'événement",
      "markAsEnd": "Marquer comme fin",
      "markUnclear": "Marquer comme indéterminé",
      "convertToAssignment": "Convertir en affectation",
      "convertToStep": "Convertir en étape",
      "mergeNode": "Fusionner avec…",
      "mergeDisabledHasSuccessor": "Seules les étapes sans successeur peuvent être fusionnées",
      "insertBetween": "Insérer une étape entre",
      "forkFromSource": "Ouvrir une branche parallèle",
      "mergeIntoTarget": "Fusionner la branche parallèle",
      "deleteEdge": "Supprimer",
      "saveAsStepTemplate_one": "Enregistrer comme modèle d'étape ({{count}} élément)",
      "saveAsStepTemplate_other": "Enregistrer comme modèle d'étape ({{count}} éléments)",
      "insertStepTemplate": "Insérer depuis un modèle d'étape"
    },
    "mergeDialog": {
      "title": "Fusionner des étapes",
      "description": "Choisissez une autre étape à fusionner avec celle-ci, puis choisissez l'étape à conserver.",
      "selectCandidate": "Étape à fusionner",
      "searchCandidates": "Rechercher des étapes…",
      "noCandidates": "Aucune autre étape à fusionner",
      "unnamedNode": "Étape sans nom",
      "assignedTo": "Attribué à : {{name}}",
      "survivorLabel": "Quelle étape conserver ?",
      "keepSource": "Conserver « {{name}} »",
      "keepTarget": "Conserver « {{name}} »",
      "resultKindStep": "Le résultat sera une étape.",
      "resultKindAssignment": "Le résultat sera une affectation.",
      "confirm": "Fusionner",
      "cancel": "Annuler"
    },
    "detailPanel": {
      "dragToMove": "Glisser pour déplacer (double-clic pour réinitialiser)",
      "dragToResize": "Glisser pour redimensionner"
    }
  },
  "processDetail": {
    "editProcess": "Modifier le processus",
    "export": {
      "title": "Exporter le processus",
      "button": "Exporter",
      "description": "Choisissez les sections à inclure dans le fichier JSON téléchargé.",
      "steps": "Étapes",
      "assignments": "Affectations",
      "capacity": "Capacité (sensible)",
      "context": "Contexte de l'organisation (rôles, départements, systèmes, équipes, organigramme)",
      "format": "Format",
      "formatJson": "JSON",
      "formatYaml": "YAML",
      "formatExcel": "Excel",
      "includeMetrics": "Inclure les indicateurs (Évaluation, Fréquence, Durée, Engagement de capacité)",
      "download": "Télécharger",
      "cancel": "Annuler",
      "success": "Processus exporté",
      "error": "Échec de l'export du processus",
      "capacitySource": "Source de capacité",
      "capacitySourceSurvey": "relevé",
      "capacitySourceManual": "saisi manuellement"
    }
  },
  "processFlowEditor": {
    "newTask": "Nouvelle tâche",
    "newDecision": "Nouvelle décision",
    "emptyNote": "Note vide",
    "noteLink": "Lier aux étapes",
    "noteLinkHint": "Cliquez sur les étapes pour les lier ou les délier · cliquez sur une zone vide pour terminer",
    "noteCategory": {
      "context": "Contexte",
      "problem": "Problème",
      "question": "Question",
      "todo": "À faire"
    },
    "ruleNoOutput": "La règle n'a pas de connexion sortante ni d'état final",
    "eventDisconnected": "L'événement n'a pas de connexion sortante",
    "sendInvitations": "Envoyer les invitations",
    "noInvitations": "Aucune invitation à envoyer",
    "sendAll": "Tout envoyer",
    "savePositions": "Enregistrer les positions",
    "pendingInvitations": "Invitations en attente ({{count}})",
    "swimlane": {
      "moveUp": "Déplacer la voie vers le haut",
      "moveDown": "Déplacer la voie vers le bas",
      "color": "Couleur de la voie",
      "resetColor": "Réinitialiser la couleur",
      "customColorPlaceholder": "#RRGGBB",
      "applyColor": "Appliquer"
    }
  },
  "processDraft": {
    "preparing": "Préparation du brouillon...",
    "loadError": "Impossible de charger le brouillon.",
    "refetchErrorBanner": "Les modifications ne sont actuellement pas enregistrées — problème de connexion ou de session. Veuillez recharger la page.",
    "draftBadge": "Brouillon",
    "lastSaved": "Enregistré {{when}}",
    "publish": "Publier",
    "discard": "Supprimer le brouillon",
    "discardConfirm": "Abandonner les modifications ?",
    "addStep": "Ajouter une étape",
    "addNote": "Ajouter une note",
    "stepDetail": "Étape",
    "assigneeSet": "Responsable sélectionné",
    "assigneeNone": "Aucun responsable",
    "pickAssignee": "Choisir un responsable",
    "pickActionType": "Choisissez un type d'action.",
    "actionTypeHint": "Décrivez ce qui se passe dans cette étape. S'il s'agit d'une tâche normale, choisissez « Activité ». Si la suite dépend de conditions (p. ex. approuvé/rejeté), choisissez « Décision ».",
    "needsInput": "Entrée requise",
    "decisionEditNotice": "Les règles de décision s'éditent sur l'étape publiée.",
    "taskDescription": "Description de la tâche",
    "taskDescriptionPlaceholder": "Que se passe-t-il dans cette étape ?",
    "confirmDeleteStep": "Supprimer cette étape du brouillon ?",
    "confirmDisconnect": "Supprimer cette connexion ?",
    "editor": {
      "generateWithAi": "Générer avec l'IA",
      "generateWithAiDisabled": "Ajoutez d'abord des entrées, une description de tâche ou des règles",
      "generateWithAiError": "Échec de la génération du résumé de l'étape",
      "descriptionPlaceholder": "Résumez cette étape…"
    },
    "mode": {
      "manual": "Manuel",
      "viral": "Viral",
      "viralDisabledReason": "Seules les étapes terminales avec une source en amont peuvent devenir des affectations virales."
    },
    "surveys": {
      "heading": "Enquêtes",
      "reRequestToggleLabel": "Redemander l'enquête à la publication",
      "reRequestToggleHint": "À la publication, les intervenants de cette étape seront invités à remplir à nouveau leur enquête.",
      "publishReRequestAll": "Publier et redemander toutes les enquêtes",
      "reRequestShort": "Redemander",
      "reRequestShortActive": "Redemande planifiée",
      "status": {
        "pending": "En attente",
        "completed": "Terminée",
        "dismissed": "N'effectue pas l'étape",
        "toCreate": "À créer",
        "invited": "Invité"
      },
      "variantStatus": {
        "pending": "Vérification des variantes en attente",
        "answered": "Vérification des variantes répondue",
        "notApplicable": "Pas de vérification des variantes"
      },
      "statusNone": "Pas encore d'enquêtes"
    },
    "unclearSuccessor": {
      "label": "Successeur incertain"
    },
    "actionType": {
      "task": "Activité",
      "decision": "Décision"
    },
    "card": {
      "unconfigured": "Étape non configurée",
      "taskLabel": "Tâche (sans description)",
      "decisionLabel": "Décision (sans règles)",
      "assigned": "Assigné",
      "pickAssignee": "Choisir un responsable",
      "needsInput": "Entrée requise",
      "willInvite": "Invitation prévue"
    },
    "graphReason": {
      "no-inputs": "Étape sans entrée",
      "no-outputs": "L'étape n'a pas de successeur",
      "orphan": "Étape non connectée",
      "no-start-event": "Le processus n'a pas d'événement de départ — rouvrez l'éditeur pour le restaurer",
      "event-disconnected": "L'événement n'a pas de connexion sortante",
      "event-disconnected-named": "L'événement « {{name}} » n'a pas de connexion sortante",
      "rule-no-output": "La règle « {{output}} » n'a pas de connexion sortante ni d'état final",
      "rule-no-output-unnamed": "Une règle de décision n'a pas de connexion sortante ni d'état final",
      "unreachable": "L'étape est isolée du reste du processus",
      "unreachable-named": "L'événement « {{name}} » est isolé du reste du processus"
    },
    "publishErrors": {
      "title": "Publication bloquée",
      "goToStep": "Aller à l'étape",
      "unnamedStep": "Étape sans nom",
      "unnamedEvent": "Événement sans nom",
      "processLevel": "Processus",
      "fieldLabels": {
        "actionType": "Type d'étape",
        "taskDescription": "Description de la tâche",
        "output": "Texte de sortie",
        "rules": "Règles",
        "assignedTo": "Responsable",
        "inputs": "Entrées",
        "helpers": "Aides",
        "helperPersons": "Aides (personnes)",
        "helperOrgFunctions": "Aides (fonctions)",
        "helperSystems": "Aides (systèmes)",
        "helperDocuments": "Aides (documents)",
        "whoElseDoesThis": "Autres participants",
        "generatedName": "Nom de l'étape",
        "generatedDescription": "Description de l'étape",
        "manualCapacity": "Capacité saisie manuellement"
      },
      "issueMessages": {
        "actionTypeRequired": "Le type d'étape est requis",
        "taskDescriptionRequired": "La description de la tâche est requise",
        "taskOutputRequired": "Le texte de sortie est requis",
        "rulesRequired": "Au moins une règle de décision est requise",
        "ruleOutputRequired": "Le résultat de la règle est requis",
        "ruleConditionRequired": "La règle doit avoir au moins une valeur de condition renseignée",
        "stepAssigneeRequired": "L'étape nécessite un responsable",
        "assignmentAssigneeRequired": "L'attribution nécessite un responsable",
        "assignmentInputRequired": "L'attribution nécessite au moins une entrée d'une étape en amont",
        "eventNameRequired": "Le nom de l'événement est requis",
        "startEventDescriptionRequired": "La description de l'événement de départ est requise"
      }
    },
    "draftConflict": {
      "title": "Les modifications de l'éditeur et l'enregistrement décentralisé sont en conflit",
      "body": "Lors de l'enregistrement décentralisé, des étapes de processus ont été saisies qui représentent un déroulement différent du dernier état non publié dans l'éditeur.",
      "yours": "Brouillon de l'éditeur",
      "live": "Enregistrement décentralisé",
      "listEmpty": "(aucun)",
      "unnamedItem": "(sans nom)",
      "cancel": "Conserver le brouillon de l'éditeur (l'état de l'enregistrement décentralisé sera écrasé)",
      "discard": "Supprimer le brouillon de l'éditeur (l'état de l'enregistrement décentralisé est correct)",
      "discardModalTitle": "Supprimer le brouillon de l'éditeur ?",
      "discardModalBody": "Cette action supprime définitivement l'intégralité de votre brouillon — toutes les modifications de toutes les étapes, pas seulement celle-ci. Le brouillon sera recréé à partir de l'état actuel de l'enregistrement décentralisé. Cette action est irréversible.",
      "discardModalCancel": "Conserver le brouillon de l'éditeur",
      "discardModalConfirm": "Supprimer le brouillon de l'éditeur",
      "publishAnyway": "Conserver le brouillon de l'éditeur (l'état de l'enregistrement décentralisé sera écrasé)",
      "publishAnywayModalTitle": "Écraser l'enregistrement décentralisé ?",
      "publishAnywayModalBody": "Vous êtes sur le point d'écraser l'état actuel de l'enregistrement décentralisé avec votre brouillon. Les enregistrements décentralisés en cours — les invitations ouvertes — risquent d'être perdus ou invalidés. Cette action est irréversible.",
      "publishAnywayModalCancel": "Retour",
      "publishAnywayModalConfirm": "Écraser",
      "unnamedStep": "Étape sans nom",
      "empty": "Étape modifiée à l'extérieur",
      "changesCount_one": "{{count}} modification",
      "changesCount_other": "{{count}} modifications"
    },
    "publishUnknownError": "Impossible de publier — veuillez réessayer.",
    "invitesFailedToast_one": "Le brouillon a été publié, mais {{count}} invitation n'a pas pu être envoyée. Les destinataires concernés devront être réinvités.",
    "invitesFailedToast_other": "Le brouillon a été publié, mais {{count}} invitations n'ont pas pu être envoyées. Les destinataires concernés devront être réinvités.",
    "issues": {
      "count_one": "{{count}} problème",
      "count_other": "{{count}} problèmes",
      "title": "Avant de publier",
      "none": "Aucun problème",
      "kinds": {
        "actionType": {
          "title": "Type d'étape manquant"
        },
        "taskDescription": {
          "title": "Description de la tâche manquante"
        },
        "output": {
          "title": "Résultat manquant"
        },
        "assignee": {
          "title": "Aucun responsable"
        },
        "rules": {
          "title": "Aucune règle de décision"
        },
        "ruleOutput": {
          "title": "Règle {{number}} : résultat manquant"
        },
        "ruleCondition": {
          "title": "Règle {{number}} : condition manquante"
        },
        "assignmentInput": {
          "title": "Aucune entrée",
          "hint": "Connectez une étape en amont à cet espace réservé."
        },
        "eventName": {
          "title": "Nom de l'événement manquant"
        },
        "eventDescription": {
          "title": "Description manquante"
        },
        "noInputs": {
          "title": "Aucune entrée",
          "hint": "Tirez une connexion depuis une étape en amont jusqu'ici."
        },
        "noOutputs": {
          "title": "Aucun successeur",
          "hint": "Connectez une étape suivante ou marquez cette étape comme fin."
        },
        "decisionNoOutputs": {
          "title": "Aucune règle n'a de cible",
          "hint": "Connectez chaque règle à une étape ou marquez-la comme fin."
        },
        "orphan": {
          "title": "Non connectée",
          "hint": "Connectez l'étape au déroulement – ou supprimez-la."
        },
        "ruleNoOutput": {
          "title": "La règle « {{output}} » n'a pas de cible",
          "titleUnnamed": "Une règle n'a pas de cible",
          "hint": "Connectez la règle à une étape ou marquez-la comme fin."
        },
        "eventDisconnected": {
          "title": "Événement non connecté",
          "hint": "Connectez l'événement à l'étape qu'il déclenche."
        },
        "unreachable": {
          "title": "Isolé du déroulement",
          "hint": "Connectez cette partie au reste du processus."
        },
        "noStartEvent": {
          "title": "Aucun événement de départ",
          "hint": "Rouvrez l'éditeur pour le restaurer."
        }
      }
    },
    "startEvent": {
      "title": "Événement de départ",
      "titleHint": "Chaque événement de départ d'un processus mène à une activité qui a lieu dans votre entreprise. Indiquez-nous qui réalise cette activité chaque fois que l'événement de départ se produit.",
      "eventTypeLabel": "Déclencheur",
      "eventTypeHint": "Le déclencheur détermine ce qui lance le processus.\n\nDémarrage manuel = Une personne lance activement le processus.\nDemande entrante = Un e-mail, une demande ou un autre système, etc. lance le processus.\nÉchéance / Délai = Le processus démarre à une date donnée ou de façon récurrente (p. ex. mensuellement).",
      "nameLabel": "Nom",
      "descriptionLabel": "Description",
      "namePlaceholder": "Qu'est-ce qui déclenche ce processus ?",
      "descriptionPlaceholder": "Décrivez ce qui déclenche cet événement (p. ex. un collaborateur soumet une demande de congé)",
      "assigneeCardSubtitle": "Choisissez qui ou quoi poursuit le travail avec l'événement de départ",
      "assigneeCardHelper": "Vous pouvez attribuer l'événement de départ à une ou plusieurs personnes, fonctions (rôles ou équipes) ou systèmes."
    },
    "event": {
      "title": "Événement",
      "eventTypeLabel": "Type d'événement",
      "nameLabel": "Nom",
      "descriptionLabel": "Description",
      "namePlaceholder": "Que représente cet événement ?",
      "descriptionPlaceholder": "Décrivez l'événement"
    },
    "capacity": {
      "title": "Capacité",
      "enter": "Saisir manuellement",
      "shadowHint": "saisi manuellement — la valeur relevée est prioritaire",
      "excludedBySettingHint": "saisi manuellement — le paramètre « Source de capacité » exclut les valeurs manuelles",
      "dialogTitle": "Saisir la capacité manuellement",
      "frequency": "Fréquence",
      "timesPerPeriod": "Nombre",
      "duration": "Durée (minutes)",
      "preview": "≈ {{month}} h/mois · {{year}} h/an par personne — extrapolé à l’équipe comme une réponse d’enquête",
      "previewPerPerson": "≈ {{month}} h/mois · {{year}} h/an par personne",
      "previewTeamTotal": "× {{count}} membres de l’équipe ≈ {{month}} h/mois · {{year}} h/an au total",
      "previewTotal": "≈ {{month}} h/mois · {{year}} h/an au total",
      "attribution": "saisi manuellement par {{name}} le {{date}}",
      "remove": "Supprimer",
      "primitives": "{{frequency}} · {{minutes}} min",
      "saveError": "La capacité n’a pas pu être enregistrée."
    }
  },
  "processes": {
    "title": "Processus",
    "description": "Aperçu de tous les processus de votre organisation",
    "search": "Rechercher des processus...",
    "createProcess": "Créer un processus",
    "editDetails": "Modifier les détails",
    "createProcessDescription": "Ajouter un nouveau processus à votre organisation",
    "editProcessDescription": "Mettre à jour les détails de ce processus",
    "empty": "Aucun processus trouvé",
    "nameLabel": "Nom du processus",
    "owner": "Propriétaire",
    "ownerPlaceholder": "Sélectionner le propriétaire du processus",
    "accountableClearLabel": "Par défaut (responsable du département)",
    "accountablePlaceholder": "Personne n'est sélectionné",
    "department": "Département",
    "departmentPlaceholder": "Sélectionner le département",
    "ownerAndDepartmentEditHint": "Contactez votre responsable d'organisation pour changer le département ou le propriétaire du processus",
    "namePlaceholder": "Saisir le nom du processus, p. ex. Soumettre une demande de congé",
    "descriptionPlaceholder": "Saisir la description du processus, p. ex. « Le processus décrit le déroulement d'une demande de congé, de la soumission à l'approbation »",
    "category": "Catégorie de processus",
    "categoryPlaceholder": "Sélectionner la catégorie",
    "notFound": "Processus non trouvé",
    "detailDescription": "Voir et gérer les détails du processus",
    "details": "Détails du processus",
    "totalSteps": "Nombre total d'étapes",
    "stepCount": "Étapes",
    "stepsCount_one": "{{count}} étape",
    "stepsCount_other": "{{count}} étapes",
    "draftEdited": "Modifié le {{when}}",
    "draftEditedBy": "Modifié le {{when}} par {{name}}",
    "recordedHeader": "Enregistré",
    "recordedTooltip": "étapes enregistrées / total des étapes connues",
    "averageRating": "Évaluation",
    "rating": "Évaluation",
    "Accountable": "Responsable",
    "ProcessOwner": "Propriétaire du processus",
    "involvedEntities": "Entités impliquées",
    "involvedPeople": "Personnes",
    "involvedTeams": "Équipes",
    "involvedFunctions": "Fonctions",
    "usedSystems": "Systèmes",
    "usedArtifacts": "Documents",
    "externalContacts": "Contacts externes",
    "usageAssigned": "Assigné à",
    "usageRecorded": "Enregistré par",
    "usageWhoElseDoesThis": "Qui d'autre fait cela",
    "usageHelper": "Assistant dans",
    "noInvolvedPeople": "Aucune personne impliquée",
    "noUsedSystems": "Aucun système utilisé",
    "noUsedArtifacts": "Aucun document utilisé",
    "noExternalContacts": "Aucun contact externe impliqué",
    "processSteps": "Étapes de processus",
    "processStep": "Étape de processus",
    "stepNumber": "Étape n°",
    "successorNumber": "Étape suivante n°",
    "successor": "Étape suivante",
    "branches": "Embranchements",
    "stepsSheet": "Étapes",
    "frequencyLabel": "Fréquence",
    "duration": "Durée",
    "inputs": "Entrées",
    "output": "Sortie",
    "processStepMembers": "Personnes de l'étape de processus",
    "helperSystems": "Assistants (Systèmes)",
    "helperPersons": "Assistants (Personnes)",
    "helperOrgFunctions": "Assistants (Fonctions)",
    "helperDocuments": "Assistants (Documents)",
    "lastChange": "Dernière modification",
    "variants": "Variantes",
    "capacityBinding": "Engagement de capacité",
    "responseCoverage": "Confiance : {{percent}} des personnes attendues ont répondu",
    "noSteps": "Aucune étape de processus trouvée",
    "minutesValue": "{{value}}min",
    "stepRecordedBy": "Étape enregistrée par {{name}}",
    "frequency": {
      "weekly": "Hebdomadaire",
      "daily": "Quotidien",
      "monthly": "Mensuel",
      "multiple-times-daily": "Plusieurs fois par jour",
      "once-a-day": "Une fois par jour",
      "several-times-a-week": "Plusieurs fois par semaine",
      "once-per-week": "Une fois par semaine",
      "every-two-weeks": "Toutes les deux semaines",
      "every-three-weeks": "Toutes les trois semaines",
      "quarterly": "Trimestriel",
      "semi-annually": "Semestriel",
      "yearly": "Annuel",
      "timesSuffix": " ({{count}}×)"
    },
    "statusNotStarted": "Non démarré",
    "statusInProgress": "En cours",
    "statusCompleted": "Terminé",
    "statusRecordingComplete": "Enregistré",
    "pendingSurveyCount_one": "{{count}} enquête ouverte",
    "pendingSurveyCount_other": "{{count}} enquêtes ouvertes",
    "deleteConfirmDescription": "Êtes-vous sûr de vouloir supprimer ce processus ? Cette action est irréversible.",
    "duplicateTitle": "Dupliquer le processus",
    "duplicateDescription": "Créez une copie de \"{{name}}\" incluant les étapes enregistrées, les attributions, les notes et la mise en page.",
    "duplicateNameDefault": "{{name}} (copie)",
    "duplicateSuccess": "Processus dupliqué avec succès",
    "duplicateFailed": "Échec de la duplication du processus",
    "incompleteStep": "En cours",
    "type": "Type",
    "task": "Tâche",
    "decision": "Décision",
    "decisionWithRules": "Décision : {{count}} règles",
    "conditions": "Conditions",
    "stepDescription": "Description de l'étape",
    "pendingAssignments": "Attributions en attente",
    "assignedTo": "Assigné à",
    "assignedBy": "Assigné par",
    "sourceStep": "Étape source",
    "status": "Statut",
    "assignedDate": "Date d'attribution",
    "noPendingAssignments": "Aucune attribution en attente",
    "processStart": "Début du processus",
    "assignmentStatus": {
      "pending": "En attente",
      "accepted": "Accepté",
      "rejected-reassigned": "Refusé - Réassigné",
      "rejected-unclear": "Refusé - Incertain",
      "pending-unclear": "En attente - Incertain",
      "unclear-reassigned": "Incertain - Réassigné"
    },
    "createProcessesPage": {
      "title": "Créer des processus",
      "description": "Ajoutez des processus à votre univers de processus. Soit en les créant manuellement, soit en les important depuis Excel.",
      "editProcessDescription": "Mettre à jour les détails de ce processus",
      "addManually": "Ajouter manuellement",
      "addManuallyDescription": "Créer un processus à l'aide du formulaire",
      "uploadFromExcel": "Importer depuis Excel",
      "uploadFromExcelDescription": "Importer plusieurs processus depuis un fichier Excel",
      "draftProcesses": "Processus brouillons",
      "noDrafts": "Aucun processus brouillon pour le moment. Ajoutez des processus pour les créer officiellement dans BLIKS IO.",
      "createAll": "Créer tous les processus",
      "cancel": "Annuler",
      "uploadSuccess_one": "{{count}} processus ajouté avec succès depuis Excel",
      "uploadSuccess_other": "{{count}} processus ajoutés avec succès depuis Excel",
      "editProcessTitle": "Modifier le processus",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer ce processus ? Cette action est irréversible.",
      "successCreated_one": "{{count}} processus créé avec succès",
      "successCreated_other": "{{count}} processus créés avec succès",
      "validationErrors": "Erreurs de validation",
      "fixErrorsWarning": "Veuillez corriger les erreurs de validation avant de créer les processus",
      "noDepartmentHead": "Le département sélectionné n'a pas de chef de département assigné."
    },
    "capacitySourceSurvey": "Relevé",
    "capacitySourceManual": "Manuel",
    "capacityManualMark": "saisi manuellement",
    "capacityEffective": "effectif",
    "capacityIncludesManual": "contient des valeurs manuelles",
    "capacityConfidence": "Confiance : {{percent}}"
  },
  "stepRecording": {
    "confirmReassign": {
      "title": "Confirmer la réassignation",
      "description": "Votre progression actuelle sera définitivement supprimée. Êtes-vous sûr de vouloir réassigner cette tâche ?",
      "assigneeLabel": "Réassigner à",
      "unclearBody": "Cette tâche sera marquée comme imprécise et transmise au propriétaire du processus."
    },
    "reassignSuccess": "Tâche réassignée avec succès",
    "reassignError": "Échec de la réassignation de la tâche. Veuillez réessayer.",
    "reassignMissingInfo": "Impossible de réassigner : informations d'enregistrement manquantes",
    "finishError": "Échec de la finalisation de l'enregistrement",
    "stopError": "Échec de l'arrêt de l'enregistrement",
    "resumeError": "Échec du retour à l'édition",
    "retryError": "Échec de la régénération du résumé",
    "review": {
      "title": "Vérifier l'étape",
      "subtitle": "Acceptez la suggestion de l'IA ou modifiez les champs individuellement avec l'icône crayon.",
      "subtitleManual": "Saisissez un titre et une description pour cette étape.",
      "titlePlaceholder": "Saisir un titre",
      "descriptionPlaceholder": "Saisir une description",
      "titleLabel": "Titre",
      "descriptionLabel": "Description",
      "back": "Retour à l'édition",
      "apply": "Appliquer",
      "editTitle": "Modifier le titre",
      "editDescription": "Modifier la description",
      "confirmEdit": "Confirmer la modification",
      "cancelEdit": "Annuler la modification",
      "generating": "Génération du résumé…",
      "generatingBanner": "Bliksy génère le résumé de votre étape…",
      "bliksySuggestion": "Suggestion de Bliksy",
      "failed": "Échec de la génération du résumé.",
      "retry": "Réessayer",
      "regenerate": "Régénérer le résumé IA",
      "aiError": "La génération du résumé IA a échoué. Utilisez le bouton de régénération pour réessayer, ou remplissez les champs manuellement."
    }
  },
  "processMap": {
    "title": "Carte des processus",
    "empty": "Aucun processus pour le moment. Créez des processus pour construire la carte",
    "kpi": {
      "total": "Processus",
      "core": "Processus clés",
      "management": "Processus de management",
      "support": "Processus de support",
      "connections": "Processus connectés",
      "isolated": "Processus isolés"
    },
    "lanes": {
      "management": "Management",
      "core": "Processus clés",
      "support": "Support",
      "uncategorized": "Non catégorisé"
    },
    "uncategorizedHint": "{{count}} processus ne sont pas encore catégorisés. Attribuez-leur une catégorie (Clé/Management/Support) pour structurer la carte.",
    "editorMode": "Modifier",
    "resetLayout": "Réinitialiser la disposition",
    "resetLayoutConfirm": "Toutes les positions manuelles seront réinitialisées. Continuer ?",
    "saveChanges": "Enregistrer",
    "discardChanges": "Annuler",
    "tooltip": {
      "connected": "Connecté",
      "notConnected": "Non connecté",
      "from": "De",
      "to": "Vers",
      "outputLabel": "Sortie",
      "startEventLabel": "Événement de départ"
    },
    "departmentFilter": {
      "placeholder": "Départements",
      "search": "Rechercher des départements...",
      "empty": "Aucun département trouvé",
      "selected": "{{count}} départements",
      "modeHighlight": "Mode surbrillance : atténue les processus non correspondants",
      "modeFilter": "Mode filtre : masque les processus non correspondants"
    },
    "search": {
      "placeholder": "Rechercher des processus...",
      "noResults": "Aucun résultat"
    },
    "chainFilter": {
      "placeholder": "Chaînes de processus",
      "search": "Rechercher une chaîne...",
      "empty": "Aucune chaîne avec des processus",
      "selected": "{{count}} chaînes",
      "modeHighlight": "Mode surbrillance : atténue les processus non correspondants",
      "modeFilter": "Mode filtre : masque les processus non correspondants"
    },
    "editorHints": {
      "dragNode": "Déplacer le processus",
      "selectArea": "Sélectionner une zone",
      "pan": "Déplacer la vue",
      "multiSelect": "Ajouter à la sélection",
      "clickPort": "Créer une connexion",
      "leftClick": "Gauche",
      "rightClick": "Droite",
      "shift": "Shift",
      "dragOnNode": "Glisser sur le processus",
      "dragOnCanvas": "Glisser sur le canevas"
    },
    "connectDialog": {
      "title": "Créer un lien",
      "description": "Voulez-vous établir le lien ?",
      "duplicateTitle": "La connexion existe déjà",
      "duplicateDescription": "Cette connexion existe déjà entre les ports sélectionnés.",
      "duplicateWarning": "Une connexion identique existe déjà. Elle ne peut pas être recréée.",
      "confirm": "lier"
    },
    "focusBadge": "Focus: {{name}}",
    "miniMap": {
      "title": "Flux de processus",
      "showInLandscape": "Afficher dans la carte",
      "noConnections": "Aucune connexion"
    }
  },
  "connections": {
    "title": "Connexions",
    "noConnections": "Ce processus n'a pas encore de connexions",
    "predecessors": "Prédécesseurs",
    "successors": "Successeurs",
    "unconnectedPorts": "Ports non connectés",
    "notConnected": "Non connecté",
    "addPredecessor": "Ajouter un prédécesseur",
    "addSuccessor": "Ajouter un successeur",
    "assignConnection": "Attribuer",
    "deleteConnection": "Supprimer la connexion",
    "deleteConnectionConfirm": "Êtes-vous sûr de vouloir supprimer cette connexion ?",
    "manageConnections": {
      "title": "Gérer les connexions : {{portName}}",
      "description": "Sélectionnez des processus et leurs ports pour créer des connexions.",
      "inputLabel": "Processus sources & leurs outputs",
      "outputLabel": "Processus cibles & leurs inputs",
      "save": "Enregistrer",
      "saving": "Enregistrement...",
      "saveFailed": "Impossible d'enregistrer les connexions"
    }
  },
  "portConnectionSelector": {
    "searchPlaceholder": "Rechercher un processus...",
    "selectedCount": "{{count}} processus sélectionné(s)",
    "noInputs": "Aucun input disponible",
    "noOutputs": "Aucun output disponible",
    "allDepartments": "Tous les départements",
    "outputCount": "{{count}} output(s)",
    "inputCount": "{{count}} input(s)"
  },
  "processChains": {
    "title": "Chaînes de processus",
    "createChain": "Nouvelle chaîne de processus",
    "categories": {
      "management": "Management",
      "core": "Clé",
      "support": "Support"
    },
    "empty": {
      "title": "Aucune chaîne de processus trouvée",
      "description": "Créez des chaînes de processus pour regrouper vos processus en flux de bout en bout."
    },
    "createDialog": {
      "name": "Nom de la chaîne",
      "namePlaceholder": "p. ex. « Order-to-Cash »",
      "description": "Description",
      "descriptionPlaceholder": "Courte description de la chaîne de processus (optionnel)",
      "category": "Catégorie de chaîne de processus"
    },
    "editChain": {
      "title": "Modifier la chaîne de processus",
      "description": "Modifier le nom, la description et la catégorie de cette chaîne de processus."
    },
    "edit": {
      "button": "Modifier",
      "title": "Gérer les processus de la chaîne",
      "description": "Ajouter, supprimer ou réorganiser les processus de cette chaîne.",
      "addProcess": "Ajouter un processus...",
      "noProcesses": "Aucun processus attribué pour le moment",
      "addProcesses": "Ajouter des processus",
      "swimlane": {
        "strategic": "Stratégique",
        "core": "Clé",
        "support": "Support"
      },
      "remove": "Supprimer",
      "autoDetect": {
        "button": "Auto-détection",
        "title": "Auto-détection de chaîne de processus",
        "description": "Sélectionnez un processus de départ. Tous les processus liés sont détectés automatiquement",
        "selectSeed": "Sélectionner le processus de départ...",
        "detected": "{{count}} processus détectés",
        "addAll": "Ajouter tous à la chaîne",
        "noConnections": "Ce processus n'a aucune connexion avec d'autres processus."
      },
      "suggestions": {
        "title": "Processus suggérés",
        "hint": "Connectés aux processus de cette chaîne"
      }
    },
    "detail": {
      "noSubChains": "Aucune sous-chaîne trouvée.",
      "emptyChainHint": "Cette chaîne n'a pas encore de processus ou de sous-chaînes."
    },
    "deleteChain": {
      "button": "Supprimer la chaîne",
      "title": "Supprimer la chaîne",
      "description": "Êtes-vous sûr de vouloir supprimer la chaîne \"{{name}}\" ?",
      "processesWillBeFreed": "{{count}} processus seront retirés de la chaîne",
      "childChainsWillBeDeleted": "{{count}} sous-chaîne(s) seront également supprimées",
      "confirm": "Supprimer la chaîne"
    },
    "drillDown": {
      "root": "Chaînes de processus",
      "childChains": "{{count}} sous-chaînes",
      "processes": "{{count}} processus",
      "emptyChain": "Cette chaîne n'a pas encore de sous-chaînes ou de processus.",
      "createSubChain": "Créer une sous-chaîne",
      "createHere": "Créer une nouvelle chaîne",
      "editProcesses": "Modifier les processus"
    }
  },
  "flowKit": {
    "toolbar": {
      "fitView": "Ajuster la vue",
      "autoLayout": "Disposition automatique",
      "undo": "Annuler",
      "redo": "Rétablir",
      "handTool": "Outil main (H)",
      "selectTool": "Outil sélection (V)"
    }
  },
  "stepTemplates": {
    "saveDialog": {
      "title": "Enregistrer comme modèle d'étape",
      "name": "Nom",
      "description": "Description",
      "selectedCount_one": "{{count}} élément sélectionné",
      "selectedCount_other": "{{count}} éléments sélectionnés",
      "unnamedStep": "Étape sans nom",
      "unnamedEvent": "Événement sans nom",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "saved": "Modèle d’étape « {{name}} » enregistré"
    },
    "insertDialog": {
      "title": "Insérer un modèle d'étape",
      "empty": "Aucun modèle d'étape enregistré pour le moment.",
      "loadError": "Impossible de charger les modèles d'étape.",
      "insert": "Insérer",
      "cancel": "Annuler",
      "edit": "Modifier",
      "delete": "Supprimer",
      "save": "Enregistrer",
      "meta_one": "{{count}} élément · {{author}} · {{date}}",
      "meta_other": "{{count}} éléments · {{author}} · {{date}}",
      "deleteConfirm": {
        "title": "Supprimer le modèle d'étape",
        "body": "« {{name}} » sera définitivement retiré de la liste. Les étapes déjà insérées restent inchangées."
      },
      "inserted": "« {{name}} » inséré"
    },
    "error": "Action échouée"
  }
}
